import './Home-mobile.scss';
import PropTypes from 'prop-types';

function HomeMobile({ className }) {
  return (
    <div className={className + ' home-new-mobile'}>
      <div>
        <p className="new-title-2">PENSAMOS, CREAMOS E INNOVAMOS PARA TI.</p>
      </div>
    </div>
  );
}


HomeMobile.propTypes = {
    className: PropTypes.string,
};

HomeMobile.defaultProps = {
    className: '',
};

export default HomeMobile;
